import { render, staticRenderFns } from "./addGiftItem.vue?vue&type=template&id=20438052"
import script from "./addGiftItem.vue?vue&type=script&lang=js"
export * from "./addGiftItem.vue?vue&type=script&lang=js"
import style0 from "./addGiftItem.vue?vue&type=style&index=0&id=20438052&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports